import moment from 'moment';

class FixedFeeBasisModificationModalController {
  constructor($scope, $uibModalInstance) {
    'ngInject';

    $scope.groupLabel = $uibModalInstance.groupLabel;
    $scope.errorMessage = '';
    $scope.effectiveDateText = '';
    $scope.modification = {
      periodOfPerformanceId: $uibModalInstance.periodOfPerformanceId,
      laborCategoryId: $uibModalInstance.laborCategoryId,
      weightedDirectLaborRate: $uibModalInstance.priorBasis ? $uibModalInstance.priorBasis.weightedDirectLaborRate : 0,
      fullyLoadedLaborRate: $uibModalInstance.priorBasis ? $uibModalInstance.priorBasis.fullyLoadedLaborRate : 0,
      fixedFeePerHour: $uibModalInstance.priorBasis ? $uibModalInstance.priorBasis.fixedFeePerHour : 0,
      maxRate: $uibModalInstance.priorBasis ? $uibModalInstance.priorBasis.maxRate : 0,
      effectiveDate: null,
      modLabel: ''
    };

    if ($uibModalInstance.suggestedEffectiveDate) {
      $scope.modification.effectiveDate = $uibModalInstance.suggestedEffectiveDate;
      $scope.effectiveDateText = moment($uibModalInstance.suggestedEffectiveDate).format('MMM DD, YYYY');
    }

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.onEffectiveDateSelected = function (selectedDate) {
      const parsed = moment(selectedDate);
      if (!parsed.isValid()) {
        return;
      }
      $scope.modification.effectiveDate = parsed.format('YYYY-MM-DD');
      $scope.effectiveDateText = parsed.format('MMM DD, YYYY');
    };

    $scope.onEffectiveDateTextChange = function () {
      if (!$scope.effectiveDateText || !$scope.effectiveDateText.trim()) {
        $scope.modification.effectiveDate = null;
        return;
      }
      const parsed = moment($scope.effectiveDateText, ['MMM DD, YYYY', 'MM/DD/YYYY', 'YYYY-MM-DD', 'MM-DD-YYYY'], true);
      if (parsed.isValid()) {
        $scope.modification.effectiveDate = parsed.format('YYYY-MM-DD');
        $scope.effectiveDateText = parsed.format('MMM DD, YYYY');
      }
    };

    $scope.missingRequiredValues = function () {
      return !$scope.modification.effectiveDate
        || !$scope.modification.modLabel
        || !$scope.modification.modLabel.trim()
        || $scope.modification.weightedDirectLaborRate == null
        || $scope.modification.fullyLoadedLaborRate == null
        || $scope.modification.fixedFeePerHour == null
        || $scope.modification.maxRate == null;
    };

    $scope.submit = function () {
      if ($scope.missingRequiredValues()) {
        return;
      }
      $uibModalInstance.close($scope.modification);
    };
  }
}

export default FixedFeeBasisModificationModalController;



// WEBPACK FOOTER //
// ./client/common/modals/fixedFeeBasisModificationModal/fixedFeeBasisModificationModal.controller.js